<lockbin-page-layout>
  <router-outlet></router-outlet>
</lockbin-page-layout>
